/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("activestorage").start()

window.Rails = Rails

require("@client-side-validations/client-side-validations")
require("@client-side-validations/simple-form")
require("bootstrap-datepicker/dist/js/bootstrap-datepicker")
require("bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min")
require("../shared/client-side-validations")
require("../shared/datepicker")

require("bootstrap");

import "controllers"

document.addEventListener("turbolinks:load", () => {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="dropdown"]').dropdown();
    const toast = $('.toast');
    toast.toast({delay: 5000});
    toast.toast('show');

})

